/* eslint-disable no-unused-vars */
import React from 'react';
// import PropTypes from 'prop-types';
import Link from '../../Services/ActiveLink'; // our version of link

class NavBarVertical extends React.Component {
  constructor() {
    super();
    this.state = {
      active: false
    };
  }

  render() {
    const { active } = this.state;
    return (
      <React.Fragment>
        <div id="selection-bar-virtical">
          <div className="selection-bar-virtical-container">
            <nav className="navigation">
              <ul className="mainmenu" activeClassName="active">
                <li>
                  <div className="style">
                    <Link activeClassName="active" href="/testformat" prefetch>
                      <a
                        onClick={() => {
                          this.setState({ active: false });
                        }}
                        className="selection-bar-virtical-container__link"
                        href="/testformat"
                      >
                        Test format and task types
                      </a>
                    </Link>
                  </div>
                </li>
                <li>
                  <div className="style">
                    <Link activeClassName="active" href="/science" prefetch>
                      <a
                        onClick={() => {
                          this.setState({ active: false });
                        }}
                        className="selection-bar-virtical-container__linkdropdown"
                        href="/science"
                      >
                        The science behind the test
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="7.41"
                          viewBox="0 0 12 7.41"
                        >
                          <path
                            id="Icon"
                            d="M617.41,2474l4.59-4.58,4.59,4.58,1.41-1.41-6-6-6,6Z"
                            transform="translate(-616 -2466.59)"
                            fill="#003399"
                          />
                        </svg>
                      </a>
                    </Link>
                  </div>
                  <ul id="submenu" activeClassName="active">
                    {/* className="submenu" i */}
                    <li />
                    <li>
                      <div className="style">
                        <Link activeClassName="active" href="/profile01" prefetch>
                          <a
                            onClick={() => {
                              this.setState({ active: false });
                            }}
                            className="selection-bar-virtical-container__link"
                            href="/profile01"
                          >
                            Dr Nick Saville
                          </a>
                        </Link>
                      </div>
                    </li>
                    <li>
                      <div className="style">
                        <Link activeClassName="active" href="/profile02" prefetch>
                          <a
                            onClick={() => {
                              this.setState({ active: false });
                            }}
                            className="selection-bar-virtical-container__link"
                            href="/profile02"
                          >
                            Dr Ardeshir Geranpayeh
                          </a>
                        </Link>
                      </div>
                    </li>
                    <li>
                      <div className="style">
                        <Link activeClassName="active" href="/profile03" prefetch>
                          <a
                            onClick={() => {
                              this.setState({ active: false });
                            }}
                            className="selection-bar-virtical-container__link"
                            href="/profile03"
                          >
                            Martin Robinson
                          </a>
                        </Link>
                      </div>
                    </li>
                    <li>
                      <div className="style">
                        <Link activeClassName="active" href="/profile04" prefetch>
                          <a
                            onClick={() => {
                              this.setState({ active: false });
                            }}
                            className="selection-bar-virtical-container__link"
                            href="/profile04"
                          >
                            Dr Jing Xu
                          </a>
                        </Link>
                      </div>
                    </li>
                    <li>
                      <div className="style">
                        <Link activeClassName="active" href="/profile05" prefetch>
                          <a
                            onClick={() => {
                              this.setState({ active: false });
                            }}
                            className="selection-bar-virtical-container__link"
                            href="/profile05"
                          >
                            Dr Kevin Cheung
                          </a>
                        </Link>
                      </div>
                    </li>
                  </ul>
                </li>
                <li>
                  <div className="style">
                    <Link activeClassName="active" href="/administer" prefetch>
                      <a
                        onClick={() => {
                          this.setState({ active: false });
                        }}
                        className="selection-bar-virtical-container__link"
                        href="/administer"
                      >
                        How to administer the test
                      </a>
                    </Link>
                  </div>
                </li>
                <li>
                  <div className="style">
                    <Link activeClassName="active" href="/results" prefetch>
                      <a
                        onClick={() => {
                          this.setState({ active: false });
                        }}
                        className="selection-bar-virtical-container__link"
                        href="/results"
                      >
                        How results are presented
                      </a>
                    </Link>
                  </div>
                </li>
                <li>
                  <div className="style">
                    <Link activeClassName="active" href="/practice" prefetch>
                      <a
                        onClick={() => {
                          this.setState({ active: false });
                        }}
                        className="selection-bar-virtical-container__link"
                        href="/practice"
                      >
                        Practice materials
                      </a>
                    </Link>
                  </div>
                </li>
                <li>
                  <div className="style">
                    <Link activeClassName="active" href="/testimonials" prefetch>
                      <a
                        onClick={() => {
                          this.setState({ active: false });
                        }}
                        className="selection-bar-virtical-container__link"
                        href="/testimonials"
                      >
                        Testimonials and case studies
                      </a>
                    </Link>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default NavBarVertical;
